import WebpackContextIcon from 'packages/helpers/WebpackContextIcon';
import {Props as SVGProps} from 'react-inlinesvg';
const iconsContext = require.context('src/icons/filter?raw', true, /\.svg$/, 'lazy-once');

export default function CategoryItemIconSimple(props: {icon?: string | null} & Omit<SVGProps, 'src'>) {
    return (
        <WebpackContextIcon
            icons={iconsContext}
            {...props}
        />
    );
}
